export const MasterDataConstants = {
    GETDEPARTMENT_REQUEST: "GET_DEPARTMENT_REQUEST",
    GETDEPARTMENT_SUCCESS: "GET_DEPARTMENT_SUCCESS",
    GETDEPARTMENT_FAILURE: "GET_DEPARTMENT_FAILURE",
  
    GETDEPARTMENTBYDESIGNATION_REQUEST: "DEPARTMENT_BY_DESIGNATION_REQUEST",
    GETDEPARTMENTBYDESIGNATION_SUCCESS: "DEPARTMENT_BY_DESIGNATION_SUCCESS",
    GETDEPARTMENTBYDESIGNATION_FAILURE: "DEPARTMENT_BY_DESIGNATION_FAILURE",
  
    GETSKILLS_REQUEST: "GET_SKILLS_REQUEST",
    GETSKILLS_SUCCESS: "GET_SKILLS_SUCCESS",
    GETSKILLS_FAILURE: "GET_SKILLS_FAILURE",

    GETDESIGNATION_REQUEST: "GET_DESIGNATION_REQUEST",
    GETDESIGNATION_SUCCESS: "GET_DESIGNATION_SUCCESS",
    GETDESIGNATION_FAILURE: "GET_DESIGNATION_FAILURE",

    CREATEMASTERDATA_REQUEST: "CREATE_MASTERDATA_REQUEST",
    CREATEMASTERDATA_SUCCESS: "CREATE_MASTERDATA_SUCCESS",
    CREATEMASTERDATA_FAILURE: "CREATE_MASTERDATA_FAILURE",

    UPDATEMASTERDATA_REQUEST: "UPDATE_MASTERDATA_REQUEST",
    UPDATEMASTERDATA_SUCCESS: "UPDATE_MASTERDATA_SUCCESS",
    UPDATEMASTERDATA_FAILURE: "UPDATE_MASTERDATA_FAILURE",


    DELETEDEPARTMENT_REQUEST: "DELETE_DEPARTMENT_REQUEST",
    DELETEDEPARTMENT_SUCCESS: "DELETE_DEPARTMENT_SUCCESS",
    DELETEDEPARTMENT_FAILURE: "DELETE_DEPARTMENT_FAILURE",

    DELETEMASTERDATA_REQUEST: "DELETE_MASTERDATA_REQUEST",
    DELETEMASTERDATA_SUCCESS: "DELETE_MASTERDATA_SUCCESS",
    DELETEMASTERDATA_FAILURE: "DELETE_MASTERDATA_FAILURE",

  };
  